import { render, staticRenderFns } from "./ListRRPlagas.vue?vue&type=template&id=6d067e2a&scoped=true"
import script from "./ListRRPlagas.vue?vue&type=script&lang=js"
export * from "./ListRRPlagas.vue?vue&type=script&lang=js"
import style0 from "./ListRRPlagas.vue?vue&type=style&index=0&id=6d067e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d067e2a",
  null
  
)

export default component.exports